<template>
    <v-container pa-0 style="max-width: 100% !important">
        <v-data-table :headers="table_headers" :items="['1']" hide-actions>
            <template slot="items">
                <tr v-for="(log, index) in logs">
                    <td>{{ log.date_created }}</td>
                    <!-- <td>{{ item[header] }}</td> -->
                    <!-- iterate through all the logs and their log details and get the user value based on the question -->
                    <td v-for="(log_detail, index) in log.logs_detail">
                        {{ log_detail.user_value }}
                    </td>

                    <td>
                        {{ log.created_by }}
                    </td>
                </tr>
            </template>
        </v-data-table>
    </v-container>
</template>

<script>
export default {
    name: "paint_process_check_sheet_table",
    props: {
        slug: {
            type: String,
            required: true,
        },
        logs: {
            type: Array,
            required: true,
        },
        log_template: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            row_headers: [],
            table_headers: [
                { text: "Date", sortable: false, width: "10%" },
                { text: "Batch No.", sortable: false, width: "256px" },
                { text: "Start Time", sortable: false, width: "256px" },
                { text: "Humidity / Temp % / F", sortable: false, width: "256px" },
                { text: "End Time", sortable: false, width: "256px" },
                { text: "Paint Portion", sortable: false, width: "256px" },
                { text: "No. of Rework Paint", sortable: false, width: "256px" },
                { text: "No. of NG Dents", sortable: false, width: "256px" },
                { text: "Total No. of NG", sortable: false, width: "256px" },
                { text: "No. of Completion", sortable: false, width: "256px" },
                { text: "Signature", sortable: false, width: "256px" },
            ],
        };
    },
    computed: {},
};
</script>
